import React from "react";
import { Card, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Button, Col, Flex, Rate, Typography } from "antd";
import { ShoppingCartOutlined, HeartFilled } from "@ant-design/icons";
import cogoToast from "cogo-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../services/react-query/queryKeys";
import { addCart } from "../../network/cart";
import useGetUserData from "../../hooks/useGetUserData";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const ProductCard = ({ product, isFavorite, onRemoveFavorite }) => {
  const { user } = useGetUserData();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const onAddCart = useMutation({
    mutationFn: (formData) => addCart(formData),
    onSuccess: (data) => {
      if (data.status === true) {
        cogoToast.success(t("messages.itemAddedSuccessfully"), { position: "top-right" });
        queryClient.invalidateQueries([queryKeys.listCart]);
      } else {
        cogoToast.warn(t("messages.warningOccurred"), { position: "top-right" });
      }
    },
  });

  const addToCart = () => {
    if (!localStorage.getItem("token")) {
      cogoToast.warn("Please login first to add items.", { position: "top-right" });
      return;
    }

    const formData = new FormData();
    formData.append("quantity", 1);
    formData.append("item_id", product.id);
    formData.append("user_id", user.id);
    formData.append("is_product", 1);
    onAddCart.mutate(formData);
  };

  return (
    <Col xl={4} lg={4} md={6} sm={12} xs={12} className="mb-2 p-1">
      <Container>
        <Card className="card-products py-3 px-3 border">
          <Link className="custom-links" to={`/productdetails/${product.id}`} style={{ textDecoration: "none" }}>
            <Card.Img className="img-fluid" src={product.image} alt={product.name} />
          </Link>

          {isFavorite && (
            <Card.ImgOverlay>
              <Button onClick={onRemoveFavorite} className="custom-button float-end" icon={<HeartFilled color="red" />} size="lg" />
            </Card.ImgOverlay>
          )}

          <Card.Body className="px-0 pt-2 pb-0 px-2">
            <Link className="custom-links" to={`/productdetails/${product.id}`} style={{ textDecoration: "none" }}>
              <span className="card-product-name">
                <p>{product.name.length > 20 ? product.name.substring(0, 17) + "..." : product.name}</p>
              </span>
              <Rate disabled defaultValue={product.average_rating} />
            </Link>

            <Flex justify="space-between" className="mt-3">
              <div>
                {product.new_price ? (
                  <Flex justify="space-evenly">
                    <Text className="mx-2">{t('currency')}{product.new_price}</Text>
                    <Text delete type="secondary">{t('currency')}{product.price}</Text>
                  </Flex>
                ) : (
                  <Text className="mx-2">{t('currency')}{product.price}</Text>
                )}
              </div>

              <Button type="primary" onClick={addToCart} icon={<ShoppingCartOutlined />} size="lg" />
            </Flex>
          </Card.Body>
        </Card>
      </Container>
    </Col>
  );
};

export default ProductCard;
